import { Error, useData, useErrors } from "../hooks/useData"

export function Errors(props: {
	prop?: string,
	onlyDisplayItems?: boolean,
}) {
	const data = useData();
	const errors = useErrors(data, props.prop);

	return (
		<ErrorsDisplay errors={errors} />
	)
}

export function ErrorsDisplay(props: {
	errors: Error[],
	onlyDisplayItems?: boolean,
}) {

	const { errors } = props;

	const items = [];
	for(let i=0;i<errors.length;i++) {
		const e = errors[i];
		if (props.onlyDisplayItems && !e.display) continue;
		
		// const propName = e.prop ? <b>{e.prop}</b> : undefined;
		items.push(
			<li key={i}>
				{/* {propName} */}
				{e.message}
			</li>
		);
	}

	return (
		<ul className="text-error">
			{items}
		</ul>
	)
}